import { useState } from "react";
import SEO from "@/components/base/SEO";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/base/Breadcrumb";

const siteUrl = "https://www.jiuseshipin.com";
const pageTitle = "关于九色视频 - 海量高清视频资源一站式平台";
const pageDesc = "了解九色视频品牌故事与发展历程，查看用户真实评价与口碑，通过在线表单联系我们。九色视频是您最值得信赖的视频内容平台。";
const pageKeywords = "九色视频,关于九色视频,九色视频品牌,九色视频联系方式,视频平台";

const testimonials = [
  {
    name: "张先生",
    role: "资深影迷",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20Chinese%20man%20in%20his%2030s%2C%20warm%20friendly%20expression%2C%20clean%20background%2C%20studio%20portrait&width=80&height=80&seq=avatar-t1&orientation=squarish",
    text: "九色视频的画质和播放体验真的太棒了！4K资源非常丰富，而且加载速度超快，几乎没有缓冲。现在每天下班后都会在上面看电影和纪录片，已经成为我生活中不可或缺的一部分。",
    rating: 5,
  },
  {
    name: "李女士",
    role: "全职妈妈",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20Chinese%20woman%20in%20her%2030s%2C%20gentle%20smile%2C%20clean%20white%20background%2C%20studio%20portrait&width=80&height=80&seq=avatar-t2&orientation=squarish",
    text: "作为宝妈，我经常在九色视频上给孩子找优质的动漫和教育类内容。分类清晰，内容安全可靠，孩子看得很开心我也很放心。智能推荐功能帮我发现了很多适合全家人一起看的好内容。",
    rating: 5,
  },
  {
    name: "王同学",
    role: "大学生",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Chinese%20man%20in%20his%2020s%2C%20bright%20smile%2C%20clean%20studio%20background&width=80&height=80&seq=avatar-t3&orientation=squarish",
    text: "九色视频的教育分类对我帮助特别大！考研期间在这里找到了非常全面的高数精讲课程，比很多付费平台的内容都要好。而且完全免费，画质清晰，真的是学生党的福音。",
    rating: 5,
  },
];

const faqs = [
  {
    q: "九色视频是什么时候成立的？",
    a: "九色视频成立于2023年，由一群热爱视频内容的创业团队创建。经过三年的快速发展，我们已经成长为拥有超过5000万活跃用户的一站式高清视频内容平台。",
  },
  {
    q: "九色视频的内容是否正版？",
    a: "九色视频始终坚持正版内容路线，与国内外多家版权方建立了深度合作关系。我们严格的内容审核机制确保平台上所有视频内容均符合版权法规要求，为用户提供安全可靠的观看环境。",
  },
  {
    q: "如何联系九色视频的客服团队？",
    a: "您可以通过本页面的联系表单提交您的需求或问题，我们的客服团队将在24小时内通过邮件回复您。对于紧急问题，您也可以关注我们的官方社交媒体账号进行咨询。",
  },
];

const schemaData = [
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "九色视频",
    "url": siteUrl,
    "description": pageDesc,
    "foundingDate": "2023",
    "logo": `${siteUrl}/logo.png`,
  },
  {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    "name": pageTitle,
    "description": pageDesc,
    "url": `${siteUrl}/about`,
    "isPartOf": { "@type": "WebSite", "name": "九色视频", "url": siteUrl },
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "首页", "item": siteUrl },
      { "@type": "ListItem", "position": 2, "name": "关于我们", "item": `${siteUrl}/about` },
    ],
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map((item) => ({
      "@type": "Question",
      "name": item.q,
      "acceptedAnswer": { "@type": "Answer", "text": item.a },
    })),
  },
];

const testimonialsSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "九色视频",
  "review": testimonials.map((t) => ({
    "@type": "Review",
    "reviewBody": t.text,
    "author": { "@type": "Person", "name": t.name },
    "reviewRating": { "@type": "Rating", "ratingValue": t.rating, "bestRating": "5" },
  })),
};

const allSchema = [...schemaData, testimonialsSchema];

export default function AboutPage() {
  const [formStatus, setFormStatus] = useState<"idle" | "success" | "error">("idle");
  const [formError, setFormError] = useState("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;

    const honeypot = (form.querySelector('input[name="phone_alt"]') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setFormStatus("success");
      return;
    }

    const formData = new FormData(form);
    formData.delete("phone_alt");

    try {
      const res = await fetch("https://readdy.ai/api/form/d9rdcdme3oq4jqumtvs0", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (res.ok && parsed?.code === "OK") {
        setFormStatus("success");
        form.reset();
      } else {
        setFormStatus("error");
        setFormError(parsed?.meta?.message || parsed?.message || "提交失败，请稍后重试。");
      }
    } catch {
      setFormStatus("error");
      setFormError("网络异常，请检查网络连接后重试。");
    }
  };

  return (
    <>
      <SEO
        title={pageTitle}
        description={pageDesc}
        keywords={pageKeywords}
        canonicalUrl={`${siteUrl}/about`}
        schemaData={allSchema}
      />

      <Navbar />

      <main className="pt-20">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <Breadcrumb
            items={[
              { label: "首页", href: "/" },
              { label: "关于我们" },
            ]}
          />
        </div>

        {/* Hero */}
        <section className="relative w-full h-[400px] md:h-[500px] flex items-center justify-center overflow-hidden">
          <div
            className="absolute inset-0 bg-cover bg-center"
            style={{
              backgroundImage: `url(https://readdy.ai/api/search-image?query=Modern%20minimalist%20office%20interior%20with%20warm%20lighting%2C%20wooden%20desk%20with%20multiple%20screens%2C%20creative%20workspace%20with%20plants%2C%20cinematic%20lighting%2C%20sophisticated%20atmosphere%2C%20warm%20amber%20and%20charcoal%20tones&width=1920&height=700&seq=about-hero-jiuse&orientation=landscape)`,
            }}
          ></div>
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50"></div>
          <div className="relative z-10 text-center px-4">
            <h1 className="text-4xl md:text-5xl font-heading font-bold text-white mb-4">
              关于九色视频
            </h1>
            <p className="text-lg text-white/70 max-w-xl mx-auto">
              汇聚海量高清资源，打造极致观影体验
            </p>
          </div>
        </section>

        {/* Brand Introduction */}
        <section id="intro" className="py-14 md:py-20 bg-background-50">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
                品牌介绍
              </h2>
              <p className="text-foreground-600">走进九色视频，了解我们的故事与使命</p>
            </div>

            <div className="space-y-8">
              <div className="bg-background-100 rounded-2xl p-8">
                <h3 className="text-xl font-heading font-semibold text-foreground-950 mb-4">我们的故事</h3>
                <p className="text-foreground-700 leading-relaxed">
                  九色视频创立于2023年，由一群怀揣着对视频内容热爱的创业伙伴共同创立。我们深知优质的视频内容能够启发灵感、
                  传递知识、连接情感，因此立志打造一个汇聚全球精品视频资源的综合性平台。
                </p>
                <p className="text-foreground-700 leading-relaxed mt-4">
                  经过三年的不懈努力，九色视频已发展成为拥有超过5000万活跃用户的一站式高清视频平台。我们的内容覆盖电影、
                  电视剧、综艺、动漫、纪录片、音乐、游戏、体育、教育等九大核心分类，每日更新海量优质视频资源。
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div className="bg-background-100 rounded-2xl p-8">
                  <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mb-4">
                    <i className="ri-focus-2-line text-xl text-primary-600"></i>
                  </div>
                  <h3 className="text-lg font-heading font-semibold text-foreground-950 mb-3">我们的使命</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    让每一个人都能轻松发现并享受高质量的视听内容。我们相信，好的视频内容应该触手可及，
                    无论你身处何地、使用何种设备，九色视频都能为你提供最佳的观影体验。
                  </p>
                </div>

                <div className="bg-background-100 rounded-2xl p-8">
                  <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center mb-4">
                    <i className="ri-eye-line text-xl text-accent-600"></i>
                  </div>
                  <h3 className="text-lg font-heading font-semibold text-foreground-950 mb-3">我们的愿景</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    成为全球最受信赖的视频内容平台。我们将持续投入技术研发和内容建设，用AI智能推荐、
                    超高清编码和全球加速网络，服务于每一位热爱视频的用户。
                  </p>
                </div>
              </div>

              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                {[
                  { num: "2023", label: "创立年份" },
                  { num: "5000万+", label: "活跃用户" },
                  { num: "10万+", label: "视频资源" },
                  { num: "99.9%", label: "服务可用率" },
                ].map((s) => (
                  <div key={s.label} className="bg-background-100 rounded-2xl p-6 text-center">
                    <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500">{s.num}</div>
                    <div className="text-sm text-foreground-500 mt-2">{s.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Reputation / Testimonials */}
        <section id="reputation" className="py-14 md:py-20 bg-background-100">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
                用户口碑
              </h2>
              <p className="text-foreground-600">来自真实用户的使用评价与反馈</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {testimonials.map((t, idx) => (
                <div key={idx} className="bg-background-50 rounded-2xl p-6">
                  <div className="flex items-center gap-1 mb-4">
                    {Array.from({ length: t.rating }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-5">{t.text}</p>
                  <div className="flex items-center gap-3">
                    <img
                      src={t.avatar}
                      alt={t.name}
                      className="w-10 h-10 rounded-full object-cover"
                    />
                    <div>
                      <div className="text-sm font-semibold text-foreground-900">{t.name}</div>
                      <div className="text-xs text-foreground-500">{t.role}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section id="faq" className="py-14 md:py-20 bg-background-50">
          <div className="max-w-3xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
                常见问题
              </h2>
            </div>

            <div className="space-y-3">
              {faqs.map((item, index) => (
                <details key={index} className="group bg-background-100 rounded-2xl overflow-hidden">
                  <summary className="flex items-center justify-between p-5 cursor-pointer list-none">
                    <h4 className="font-heading font-semibold text-foreground-900 text-base pr-4">
                      {item.q}
                    </h4>
                    <div className="w-7 h-7 rounded-full bg-background-200 flex items-center justify-center flex-shrink-0 group-open:rotate-45 transition-transform duration-300">
                      <i className="ri-add-line text-foreground-600"></i>
                    </div>
                  </summary>
                  <div className="px-5 pb-5">
                    <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>

        {/* Contact Form */}
        <section id="contact" className="py-14 md:py-20 bg-background-100">
          <div className="max-w-2xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
                联系我们
              </h2>
              <p className="text-foreground-600">有任何问题或建议？请通过以下表单与我们联系</p>
            </div>

            <div className="bg-background-50 rounded-2xl p-8">
              {formStatus === "success" ? (
                <div className="text-center py-8">
                  <div className="w-16 h-16 rounded-full bg-emerald-100 flex items-center justify-center mx-auto mb-4">
                    <i className="ri-check-line text-2xl text-emerald-600"></i>
                  </div>
                  <h3 className="text-xl font-heading font-semibold text-foreground-950 mb-2">提交成功!</h3>
                  <p className="text-foreground-600">感谢您的留言，我们的团队将在24小时内回复您。</p>
                  <button
                    onClick={() => setFormStatus("idle")}
                    className="mt-6 px-6 py-2.5 bg-background-100 hover:bg-background-200 text-foreground-700 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
                  >
                    继续留言
                  </button>
                </div>
              ) : (
                <form data-readdy-form onSubmit={handleSubmit} noValidate>
                  <div className="honeypot-wrapper">
                    <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
                  </div>

                  <div className="space-y-5">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                      <div>
                        <label htmlFor="name" className="block text-sm font-medium text-foreground-700 mb-1.5">
                          姓名 <span className="text-primary-500">*</span>
                        </label>
                        <input
                          type="text"
                          id="name"
                          name="name"
                          required
                          className="w-full px-4 py-2.5 rounded-xl bg-background-100 border border-background-200 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                          placeholder="请输入您的姓名"
                        />
                      </div>
                      <div>
                        <label htmlFor="email" className="block text-sm font-medium text-foreground-700 mb-1.5">
                          邮箱 <span className="text-primary-500">*</span>
                        </label>
                        <input
                          type="email"
                          id="email"
                          name="email"
                          required
                          className="w-full px-4 py-2.5 rounded-xl bg-background-100 border border-background-200 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                          placeholder="请输入您的邮箱地址"
                        />
                      </div>
                    </div>

                    <div>
                      <label htmlFor="subject" className="block text-sm font-medium text-foreground-700 mb-1.5">
                        主题
                      </label>
                      <input
                        type="text"
                        id="subject"
                        name="subject"
                        className="w-full px-4 py-2.5 rounded-xl bg-background-100 border border-background-200 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                        placeholder="请选择或输入咨询主题"
                      />
                    </div>

                    <div>
                      <label htmlFor="message" className="block text-sm font-medium text-foreground-700 mb-1.5">
                        留言内容 <span className="text-primary-500">*</span>
                      </label>
                      <textarea
                        id="message"
                        name="message"
                        rows={5}
                        required
                        maxLength={500}
                        className="w-full px-4 py-2.5 rounded-xl bg-background-100 border border-background-200 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors resize-none"
                        placeholder="请输入您想咨询的内容（最多500字）"
                      ></textarea>
                    </div>

                    {formStatus === "error" && (
                      <div className="flex items-center gap-2 p-3 rounded-xl bg-rose-50 text-rose-700 text-sm">
                        <i className="ri-error-warning-line"></i>
                        <span>{formError}</span>
                      </div>
                    )}

                    <button
                      type="submit"
                      className="w-full py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-xl text-sm transition-colors cursor-pointer whitespace-nowrap"
                    >
                      提交留言
                    </button>
                  </div>
                </form>
              )}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}